import { TeamService, ITeam, ILocation, IContact } from "../../../services/index";
import * as _ from "lodash";
interface IResolve {
    locations: ILocation[];
    contacts: IContact[];
}

class TeamsItemController {

    private resolve: IResolve;
    private location: ILocation;
    private team: ITeam;
    private contacts: IContact[];
    private newContact: IContact;

    constructor(
        private TeamService: TeamService,
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService,
        private $timeout: ng.ITimeoutService,
        private SweetAlert: any
    ) {
        'ngInject';
    }


    public $onInit = () => {
        this.contacts = this.resolve.contacts;
        var locationId : string = this.$stateParams['locationId'];
        var teamId : string = this.$stateParams['teamId'];
        this.location = _.find(this.resolve.locations, { 'id': locationId });
        this.$timeout(() => {
            if (teamId != '') {
                this.TeamService.get(teamId).then((result) => {
                    this.team = result;
                });
                // this.team =  _.find(this.location.teams, { 'id': teamId });
            } else {
                this.team = new ITeam();
            }

            // console.log(this.location);
            // console.log(this.location.teams);
            // console.log(teamId);
        });
    }

    public submitTeam() {
        if (this.team.id === undefined) {
            this.team.locationId = this.location.id.toString();
            this.TeamService.post(this.team).then((data) => {
                this.closeModal();
            });
            // this.teams.push(this.team);
        } else {
            this.TeamService.put(this.team.id, this.team).then((data) => {
                this.closeModal();
            });
        }
    }

    delete() {

        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u '+ this.team.name +' wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.TeamService.delete(this.team.id).then((data) => {
                    this.closeModal();
                });
            } else {

            }
        });        
     
    }

    addContact() {
        // console.log(this.newContact);
        var teamContact = <any>{ teamId: this.team.id, contactId: this.newContact.id };
        this.TeamService.postChild(teamContact, this.team.id, 'teamContacts').then((result) => {
            this.$state.go('.', {tab: 2}, {reload: true});
            // teamContact = result;
            // teamContact.contactName = this.newContact.name;
            // this.team.teamContacts.push(teamContact);
        });
    }

    deleteContact(event, item) {
        event.stopPropagation();
        this.TeamService.deleteChild(item.id, this.team.id, 'teamContacts').then(() => {
            this.$state.go('.', {tab: 2}, {reload: true});
            // this.team.teamContacts = this.team.teamContacts.filter(tc => tc.id != item.id);
        });
    }

    private closeModal() {
        this.$state.go('^', {tab: 3}, {reload: true});
    }

    copyGuid() {
        window.navigator['clipboard'].writeText(this.team.id.toString());
        alert("De Guid van " + this.team.name + "is gekopieerd");
    }
}

export const teamsItemComponent = { 
    bindings: {
        resolve : "<",
        close: "&"
    },
    controller: TeamsItemController,
    template: require('./teams.item.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/teams/teams.item.component.ts